(function () {
  function setup(viewport) {
    var track = viewport.querySelector('.instagram-gallery__track');
    if (!track) return;

    var originalItems = Array.prototype.slice.call(track.children);
    if (originalItems.length < 2) return;

    var carousel = viewport.closest('.instagram-gallery__carousel') || viewport.parentElement;
    var prevBtn = carousel ? carousel.querySelector('[data-instagram-prev]') : null;
    var nextBtn = carousel ? carousel.querySelector('[data-instagram-next]') : null;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var interval = parseInt(viewport.getAttribute('data-interval'), 10) || 1500;
    var total = originalItems.length;

    originalItems.forEach(function (item) {
      track.appendChild(item.cloneNode(true));
    });

    var index = 0;
    var paused = false;
    var timer = null;

    function itemWidth() {
      return track.children[0].getBoundingClientRect().width;
    }

    function advance() {
      if (paused || document.hidden) return;

      index++;
      track.style.transition = 'transform 0.6s ease';
      track.style.transform = 'translateX(-' + index * itemWidth() + 'px)';

      if (index >= total) {
        window.setTimeout(function () {
          track.style.transition = 'none';
          index = 0;
          track.style.transform = 'translateX(0px)';
          void track.offsetWidth;
        }, 620);
      }
    }

    function goPrev() {
      if (index > 0) {
        index--;
        track.style.transition = 'transform 0.6s ease';
        track.style.transform = 'translateX(-' + index * itemWidth() + 'px)';
      } else {
        track.style.transition = 'none';
        index = total - 1;
        track.style.transform = 'translateX(-' + index * itemWidth() + 'px)';
        void track.offsetWidth;
        track.style.transition = 'transform 0.6s ease';
      }
    }

    function goNext() {
      advance();
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + index * itemWidth() + 'px)';
      }, 150);
    });

    viewport.addEventListener('mouseenter', function () {
      paused = true;
    });
    viewport.addEventListener('mouseleave', function () {
      paused = false;
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goPrev();
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goNext();
        start();
      });
    }

    start();
  }

  function showPanel(modal, index) {
    var panels = modal.querySelectorAll('[data-shop-the-look-panel]');
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-index') !== String(index);
    });
  }

  function setupShopTheLook() {
    document.querySelectorAll('[data-shop-the-look-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        var modalSelector = trigger.getAttribute('data-modal');
        var modal = modalSelector ? document.querySelector(modalSelector) : null;
        if (!modal || typeof modal.show !== 'function') return;

        event.preventDefault();
        showPanel(modal, trigger.getAttribute('data-index'));
        modal.show(trigger);
      });
    });

    document.querySelectorAll('.shop-the-look-modal').forEach(function (modal) {
      // The nav/close row is now duplicated inside every panel (so it can sit
      // in normal document flow directly under that panel's own image,
      // instead of floating over it) — wire every instance, not just the
      // first, since only the currently-visible panel's copy is ever
      // reachable anyway.
      var prevBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-shop-the-look-prev]'));
      var nextBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-shop-the-look-next]'));
      var closeBtns = Array.prototype.slice.call(modal.querySelectorAll('[id^="ModalClose-"]'));
      var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-shop-the-look-panel]'));
      var total = panels.length;

      function currentIndex() {
        var visible = panels.filter(function (panel) {
          return !panel.hidden;
        })[0];
        return visible ? parseInt(visible.getAttribute('data-index'), 10) : 0;
      }

      function step(delta) {
        if (!total) return;
        showPanel(modal, (currentIndex() + delta + total) % total);
      }

      if (total < 2) {
        prevBtns.forEach(function (btn) { btn.hidden = true; });
        nextBtns.forEach(function (btn) { btn.hidden = true; });
      } else {
        prevBtns.forEach(function (btn) { btn.addEventListener('click', function () { step(-1); }); });
        nextBtns.forEach(function (btn) { btn.addEventListener('click', function () { step(1); }); });
      }

      // global.js's <modal-dialog> only wires the first [id^="ModalClose-"]
      // it finds; explicitly wire every duplicate here so close works from
      // whichever panel is currently showing.
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof modal.hide === 'function') modal.hide();
        });
      });

      modal.querySelectorAll('[data-shop-the-look-copy-link]').forEach(function (button) {
        button.addEventListener('click', function () {
          var url = button.getAttribute('data-shop-the-look-copy-link');
          if (!url || !navigator.clipboard) return;
          navigator.clipboard.writeText(url).then(function () {
            var original = button.getAttribute('aria-label');
            var copiedLabel = button.getAttribute('data-copied-label') || original;
            button.setAttribute('aria-label', copiedLabel);
            window.setTimeout(function () {
              button.setAttribute('aria-label', original);
            }, 1500);
          });
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-instagram-slideshow]').forEach(setup);
    setupShopTheLook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
